import { getEnvVar } from './utils';

export const USER_API = getEnvVar(
  process.env.PHARMACY_USERS_API,
  'https://api.dev.wellbd.co.uk/users'
);
export const PHARMACY_API = getEnvVar(
  process.env.PHARMACY_PHARMACY_API,
  'https://api.dev.wellbd.co.uk/pharmacy'
);
export const MEDICINE_API = getEnvVar(
  process.env.PHARMACY_MEDICINE_API,
  'https://api.dev.wellbd.co.uk/dmd'
);
export const GP_PROFILE_API = getEnvVar(
  process.env.PHARMACY_GP_PROFILES_API,
  'https://api.dev.wellbd.co.uk/gp-profiles'
);

export const LOGIN_REDIRECTION_URL = getEnvVar(
  process.env.LOGIN_REDIRECTION_URL,
  'https://bigcommerce.dev.wellbd.co.uk/login.php'
 
);

export const API_ENDPOINT = getEnvVar(
  process.env.API_ENDPOINT,
  'https://api.dev.wellbd.co.uk'
 
);

export const NMS_API = getEnvVar(
  process.env.PHARMACY_NMS_API,
  `${API_ENDPOINT.replace(/\/$/, '')}/nms`
);

export const NMS_GATEWAY_PATH = '/api/nms';
